/* eslint-disable no-param-reassign */

import MD from 'mobile-detect';

const MobileDetect = {
  install(Vue) {
    Vue.prototype.$md = new MD(window.navigator.userAgent);
  },
};

export default MobileDetect;
